import React from "react";
import BrowseMovies from "../components/BrowseMovies";

const Browse = () => {
  return <BrowseMovies />;
};

export default Browse;
